"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatesTabPanel = exports.StatesTabPanelFull = void 0;
const react_redux_1 = require("react-redux");
const React = require("react");
const core_1 = require("@material-ui/core");
const ShapeLegend_1 = require("./ShapeLegend/ShapeLegend");
const SelectedVectorByShapeDuck_1 = require("../../Ducks/SelectedVectorByShapeDuck");
const VectorByShapeDuck_1 = require("../../Ducks/VectorByShapeDuck");
const CheckedShapesDuck_1 = require("../../Ducks/CheckedShapesDuck");
const mapStateToProps = state => ({
    selectedVectorByShape: state.selectedVectorByShape,
    vectorByShape: state.vectorByShape,
    dataset: state.dataset,
    categoryOptions: state.categoryOptions
});
const mapDispatchToProps = dispatch => ({
    setSelectedVectorByShape: selectedVectorByShape => dispatch(SelectedVectorByShapeDuck_1.setSelectedVectorByShapeAction(selectedVectorByShape)),
    setVectorByShape: vectorByShape => dispatch(VectorByShapeDuck_1.setVectorByShapeAction(vectorByShape)),
    setCheckedShapes: checkedShapes => dispatch(CheckedShapesDuck_1.setCheckedShapesAction(checkedShapes))
});
exports.StatesTabPanelFull = ({ selectedVectorByShape, vectorByShape, dataset, setSelectedVectorByShape, setVectorByShape, setCheckedShapes, categoryOptions }) => {
    return React.createElement("div", null,
        categoryOptions != null && categoryOptions.hasCategory("shape") ?
            React.createElement(core_1.Grid, { container: true, justify: "center", alignItems: "stretch", direction: "column", style: { padding: '0 16px' } },
                React.createElement(core_1.FormControl, { style: { margin: '4px 0px' } },
                    React.createElement(core_1.InputLabel, { shrink: true, id: "vectorByShapeSelectLabel" }, "shape by"),
                    React.createElement(core_1.Select, { labelId: "vectorByShapeSelectLabel", id: "vectorByShapeSelect", displayEmpty: true, value: selectedVectorByShape, onChange: (event) => {
                            setSelectedVectorByShape(event.target.value);
                            if (event.target.value != null && event.target.value != "") {
                                var attribute = categoryOptions.getCategory("shape").attributes.filter(a => a.key == event.target.value)[0];
                                setVectorByShape(attribute);
                            }
                            else {
                                setVectorByShape(null);
                            }
                        } },
                        React.createElement(core_1.MenuItem, { value: "" }, "None"),
                        categoryOptions.getCategory("shape").attributes.map(attribute => {
                            return React.createElement(core_1.MenuItem, { key: attribute.key, value: attribute.key }, attribute.name);
                        }))))
            :
                React.createElement("div", null),
        React.createElement(core_1.Grid, { item: true, style: { padding: '0 16px' } },
            React.createElement(ShapeLegend_1.ShapeLegend, { dataset: dataset, category: vectorByShape, onChange: (checkboxes) => {
                    setCheckedShapes(checkboxes);
                } })));
};
exports.StatesTabPanel = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.StatesTabPanelFull);
